module.exports = __webpack_public_path__ + "img/menu_head.1c931282.png";